/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type CycleTimeReportEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const cycleTimeReportEntrypoint: EntryPoint<CycleTimeReportEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<CycleTimeReportEntrypointComponent>(
			/* webpackChunkName: "async-cycle-time-report-entrypoint" */ './CycleTimeReportCycleTimeReportSpa.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
